export const DIRECTOR_ROUTE_NAMES = {
    LIST: "DirectorList",
    PROFILE: "DirectorProfile",
};
